import React from "react";
import { useParams } from "react-router-dom";
import { PreviewQualifiedInvoice } from "../../../../organisms/smart-apply/qualified-invoice/preview";
import { SmartApplyTemplate } from "../../../../template/smart-apply/default-template";
import { SmartApplyR } from "../../route";
import { SmartApplyMenuList } from "../../../../organisms/smart-apply/menu-list";
import { useQualifiedInvoiceShowContainer } from "./hooks";
import { Spinner } from "@graffer-inc/console-design-kit";
import { TabUiState } from "../../../../../application/service/smart-apply/application-detail/tab-ui-state";
import { ResourceFetchError } from "../../../../organisms/common/resource-fetch-error";

export const QualifiedInvoiceShowContainer: React.FC = () => {
  const title = "交付済み支払い明細書";

  const { id: aplId } = useParams<{ id: string }>();
  const { qualifiedInvoiceId } = useParams<{ qualifiedInvoiceId: string }>();
  const { isLoading, invoice } = useQualifiedInvoiceShowContainer({
    qualifiedInvoiceId,
    applicationId: aplId,
  });

  const transactionDate = invoice?.detail.transactionDate;

  return (
    <SmartApplyTemplate
      breadcrumbs={[
        { to: SmartApplyR.Applications.link({}), title: "申請一覧" },
        {
          to: SmartApplyR.ApplicationDetail.link({
            id: aplId,
            tab: TabUiState.payment(),
          }),
          title: aplId,
        },
        {
          to: SmartApplyR.ApplicationQualifiedInvoiceShow.link({
            id: aplId,
            qualifiedInvoiceId,
          }),
          title: title,
        },
      ]}
      menuList={<SmartApplyMenuList />}
    >
      <Spinner loading={isLoading} />
      {!isLoading &&
        (invoice ? (
          <div
            style={{
              maxWidth: "800px",
            }}
          >
            <h1 className="title">
              <i className="fa fa-file-invoice mr-1" />
              {title}
            </h1>
            <PreviewQualifiedInvoice
              buyerName={invoice.detail.buyerName || ""}
              businessIssuer={invoice.detail.qualifiedInvoiceBusinessIssuer!}
              transactionDate={`${transactionDate?.year}年${transactionDate?.month}月${transactionDate?.day}日`}
              detailPayment={invoice.detail.payment}
            />
          </div>
        ) : (
          <ResourceFetchError
            title=""
            subtitle="支払い明細書が見つかりませんでした。"
          />
        ))}
    </SmartApplyTemplate>
  );
};
